import {
  Component,
  computed,
  inject,
  Signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { Router, RouterLink } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { ButtonBadgeComponent } from 'src/app/common/button-badge/button-badge.component';
import { CartService } from 'src/app/services/Customer/Cart/cart.service';
import { CartItem } from 'src/app/interfaces/cart-item';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { NavLinkComponent } from './nav-link/nav-link.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { CurrentUser } from 'src/app/interfaces/current-user';
import { LoginModalService } from 'src/app/services/LoginModal/login-modal.service';
import { NotificationsV1Component as NotificationsComponent } from 'src/app/common/templates/header/notifications-v1/notifications-v1.component';
import { SearchSuggestComponent } from "src/app/common/search-suggest/search-suggest.component";

@Component({
  selector: 'customer-header',
  imports: [
    RouterLink,
    FormsModule,
    ButtonBadgeComponent,
    NavLinkComponent,
    SidebarComponent,
    RouterLink,
    NotificationsComponent,
    SearchSuggestComponent
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {

  // views
  web_user_badge = viewChild<ButtonBadgeComponent>('web_user_badge');

  // injectables
  auth = inject(AuthService)
  router = inject(Router)
  cartApi = inject(CartService)
  toast = inject(ToastService)
  loginModal = inject(LoginModalService)

  // data
  user: Signal<CurrentUser | null>;
  username: Signal<string>;
  isLogged: Signal<boolean>;
  search_query: string = '';
  cart!: WritableSignal<CartItem[]>;
  navLinks!: CustomerNavLink[];
  
  constructor(
  ) {
    this.isLogged = this.auth.getAuthState();
    this.user = computed(() => this.auth.getCurrentUser());
    this.username = computed(() => this.getUsername());
    this.cart = this.cartApi.getCart();
  }
  ngOnInit() {
    this.navLinks = [
      {
        name: 'home',
        url: 'browse',
        withAuth: false,
      },
      {
        name: 'Quotations',
        url: 'browse/quotation',
        withAuth: true,
      },
    ];
  }

  ngAfterViewInit() {
    // read storage for modal trigger
    const trigger = localStorage.getItem('trigger');

    if (trigger) {
      this.login();
      localStorage.removeItem('trigger');
    }
  }

  getUsername() {
    return this.user()?.first_name != null || this.user()?.last_name != null
      ? `${this.user()?.first_name} ${this.user()?.last_name}`
      : '';
  }
  logout() {
    this.auth
      .logout()
      .subscribe({ complete: () => (window.location.href = '/') });
  }
  login() {
    this.loginModal.getInstance().onShow();
  }
  search() {
    const query = this.search_query.trim();
    if (!query) {
      return;
    }
    this.search_query = '';
    this.router.navigate(['/browse'], { queryParams: { q: query } });
  }

  whoAmI() {
    return this.auth.getCurrentRole() === 'customer' ? '/user' : this.auth.getRoleIndex();
  }
}

export interface CustomerNavLink {
  name: string;
  url: string;
  withAuth: boolean;
}
